import { AxiosRequestConfig, AxiosResponse } from "axios";
import apiGuard from "../../../context-controller-mod/context-serv/global-provider/api-shell/api-gaurd";

const ApiDelete = <T = unknown>(
  url: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<T>> => {
  return apiGuard.delete<T>(url, config);
};

export default ApiDelete;